import {Injectable} from '@angular/core';
import { ActivatedRouteSnapshot, RouterStateSnapshot } from '@angular/router';
import {Observable, Subject} from 'rxjs';
import {AddingEmployeeComponent} from '../components/profile/adding-employee/adding-employee.component';
import {ProfileComponent} from '../components/profile/profile/profile.component';
import {CloseHandlerService} from '../services/close-handler.service';
import {SureModalService} from '../services/sure-modal/sure-modal.service';
import {SURE_MODAL_TEXT} from '../shared/utils/constants';

@Injectable({
  providedIn: 'root',
})
export class CheckTabsChangesGuard  {
  constructor(
    private closeHandler: CloseHandlerService,
    private sureModalService: SureModalService
  ) {}

  canDeactivate(
    component: AddingEmployeeComponent | ProfileComponent,
    currentRoute: ActivatedRouteSnapshot,
    currentState: RouterStateSnapshot,
    nextState?: RouterStateSnapshot
  ): Observable<boolean> | boolean {
    const res = new Subject<boolean>();
    if (this.closeHandler.notSaved) {
      this.sureModalService
        .openModal({text: SURE_MODAL_TEXT.CHANGES_TEXT})
        .subscribe(result => {
          if (!result) {
            this.closeHandler.notSaved = false;
            this.closeHandler.notSaveForm.next(true);
            res.next(true);
          } else {
            this.closeHandler.clickSavePopup.next(true);
            res.next(false);
          }
        });
    } else return true;
    return res;
  }
}
